import { Route } from "react-router-dom";

import { DeviationCreate } from "./Create/Create";
import { DeviationEdit } from "./Edit/Edit";

const resource = "deviations";

export const deviationsRoutes = {
	create: (
		<Route
			exact
			path={`/orders/:order_id/show/${resource}/create`}
			component={(props) => (
				<DeviationCreate
					basePath={`/orders/${props.match.params.order_id}/show/${resource}`}
					orderId={props.match.params.order_id}
					resource={resource}
				/>
			)}
		/>
	),
	edit: (
		<Route
			exact
			path={`/orders/:order_id/show/${resource}/:id`}
			component={(props) => (
				<DeviationEdit
					basePath={`/orders/${props.match.params.order_id}/show/${resource}`}
					id={props.match.params.id}
					resource={resource}
				/>
			)}
		/>
	),
};
